import PropTypes from 'prop-types'

import { Container } from './styles'

const providerMap = {
  google: 'google-calendar',
  outlook: 'outlook',
  icloud: 'icloud',
  outlook_desktop: 'outlook-desktop',
  exchange: 'exchange'
}

const CalendarProviderIcon = ({ provider, ...restProps }) => {
  const iconName = providerMap[provider]

  return <Container {...restProps} provider={iconName} />
}

CalendarProviderIcon.propTypes = {
  provider: PropTypes.string.isRequired,
}

export default CalendarProviderIcon
